import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import adminTracking from "@irati-tracking/admin"

interface Props {
  show: boolean
  upsell?: boolean
  onClose: () => void
  onReturn: () => void
}

const AbandonModal: FC<Props> = ({show, upsell, onClose, onReturn}) => {
  const handleOnReturn = () => {
    adminTracking.hrisUpsellSetup(upsell ? "admin_dysnc_purchase_exit" : "admin_dysnc_set_up_exit", {
      action: upsell ? "purchase_return" : "set_up_return"
    })
    onReturn()
  }

  const handleOnClose = () => {
    adminTracking.hrisUpsellSetup(upsell ? "admin_dysnc_purchase_exit" : "admin_dysnc_set_up_exit", {
      action: upsell ? "purchase_exit" : "set_up_exit"
    })
    onClose()
  }
  return (
    <GenericModal customWidth={750} hideActions show={show} onHide={handleOnClose}>
      <H2 marginBottom>
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.abandonModal.title" />
      </H2>
      <Body marginBottom={3} maxWidth="100%">
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.abandonModal.subTitle" />
      </Body>
      <Flex alignItems="center" justifyContent="flex-end" gap={5}>
        <Button primary onClick={handleOnReturn}>
          <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.abandonModal.returnBtn" />
        </Button>
        <Button tertiary onClick={handleOnClose} marginRight={5}>
          <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.abandonModal.closeBtn" />
        </Button>
      </Flex>
    </GenericModal>
  )
}

export default AbandonModal
